module.exports = __webpack_public_path__ + "media/icons/twitter-1d9fe80fc91652f515b75a0f1f8544e6.svg";